export default __webpack_public_path__ + "static/media/interest.4edc5977.svg";